import { render, staticRenderFns } from "./historyChat.vue?vue&type=template&id=79348e14&scoped=true"
import script from "./historyChat.vue?vue&type=script&lang=js"
export * from "./historyChat.vue?vue&type=script&lang=js"
import style0 from "./historyChat.vue?vue&type=style&index=0&id=79348e14&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79348e14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79348e14')) {
      api.createRecord('79348e14', component.options)
    } else {
      api.reload('79348e14', component.options)
    }
    module.hot.accept("./historyChat.vue?vue&type=template&id=79348e14&scoped=true", function () {
      api.rerender('79348e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarSearch/comps/historyChat.vue"
export default component.exports